// extracted by mini-css-extract-plugin
module.exports = {"host":"HeaderSearchPortal_host__YLRRI"};